<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2b"><a id="page_xix"></a><a id="frontmatter03"></a>NOTE ON FILM TITLES</h2>
<p class="para">Most of the Euro horror films discussed in this book have at least two different titles: their original, foreign-language titles and the English ones they were given upon their American theatrical or home video premiere. Many, however, have acquired other titles as they have been released and re-released in different markets over the years. Consider the (admittedly extreme) case of Mario Bava’s 1971 film, <em>Bay of Blood,</em> which has played to audiences around the world under more than a dozen titles, including <em>Reazione a catena, Antefatto – Ecologia del delitto, Bloodbath, The Last House on the Left: Part II,</em> and (my favorite) <em>Twitch of the Death Nerve.</em> To avoid confusion, I have elected to introduce the Euro horror films discussed in this book by their original, foreign-language titles, followed in parentheses by the English titles under which they are most widely known and available in the United States today; all subsequent references use the English titles. Thus the aforementioned Bava film would be introduced as <em>Reazione a catena</em> (<em>Bay of Blood,</em> 1971) and thereafter referred to as <em>Bay of Blood.</em> Readers who look up a Euro horror film in the index will find the foreign-language title there, though they will be directed to the English title for a list of the pages on which the film is discussed.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter03.vue?2be5c001